import { render } from "./Chat.vue?vue&type=template&id=14f4e39a&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=14f4e39a&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f4e39a"]])

export default __exports__